import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PhoneDropdown from './PhoneDropdown';
import '../styles/header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll for header shadow
  useEffect(() => {
    let rAF;
    const onScroll = () => {
      if (rAF) return;
      rAF = requestAnimationFrame(() => {
        const header = document.querySelector('.site-header');
        if (header) {
          if (window.scrollY > 10) {
            header.classList.add('site-header--shadow');
          } else {
            header.classList.remove('site-header--shadow');
          }
        }
        rAF = null;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    closeMobileMenu();
  };

  return (
    <>
      <header className="site-header">
        <div className="site-header__inner">
          {/* Logo */}
          <Link to="/" className="site-logo" onClick={handleLogoClick}>
            <img 
              src="/main logo.png" 
              alt="WAKAGYROS" 
              className="logo-image"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="site-nav" role="navigation" aria-label="Fő navigáció">
            <a 
              href="#home" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Kezdőoldal
            </a>
            <a 
              href="#menu" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Menü
            </a>
            <a 
              href="#about" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Rólunk
            </a>
            <a 
              href="#kapcsolat" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('kapcsolat')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Kapcsolat
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="hamburger-btn"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          {/* CTA Button */}
          <PhoneDropdown />
        </div>
      </header>

      {/* Mobile Menu */}
      <nav 
        className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`} 
        role="navigation" 
        aria-label="Mobil navigáció"
      >
        <a 
          href="#home" 
          onClick={(e) => {
            e.preventDefault();
            closeMobileMenu();
            document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Kezdőoldal
        </a>
        <a 
          href="#menu" 
          onClick={(e) => {
            e.preventDefault();
            closeMobileMenu();
            document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Menü
        </a>
        <a 
          href="#about" 
          onClick={(e) => {
            e.preventDefault();
            closeMobileMenu();
            document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Rólunk
        </a>
        <a 
          href="#kapcsolat" 
          onClick={(e) => {
            e.preventDefault();
            closeMobileMenu();
            document.getElementById('kapcsolat')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Kapcsolat
        </a>
      </nav>
    </>
  );
};

export default Header;
